import React from 'react'
import Calculator from '@/components/Calculator'

export default function MetalRoofingPage() {
  const metalTypes = [
    { name: 'Standing Seam Metal', costPerSqFt: '$10 - $16', durability: 'Excellent', appearance: 'Modern, Sleek' },
    { name: 'Copper Roof', costPerSqFt: '$25 - $40', durability: 'Exceptional', appearance: 'Luxury, Patina' },
    { name: 'Aluminum Roofing', costPerSqFt: '$7 - $11', durability: 'Very Good', appearance: 'Lightweight, Rust-Free' },
    { name: 'Steel Metal Roof', costPerSqFt: '$6 - $10', durability: 'Excellent', appearance: 'Industrial, Strong' },
  ]

  return (
    <div className="bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-800 to-gray-900 text-white py-12 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h1 className="text-4xl sm:text-5xl font-bold mb-4">
              Metal Roof Installation Cost Calculator
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Calculate accurate estimates for standing seam metal, copper, aluminum, and steel roofing systems. Get instant pricing for premium metal roof installations.
            </p>
          </div>

          <div className="flex justify-center">
            <Calculator materialType="metal" title="Metal Roof Estimate Calculator" />
          </div>
        </div>
      </section>

      {/* Metal Roofing Benefits */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-12">
            Why Choose Metal Roofing?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-bold text-xl text-gray-900 mb-3">Longevity</h3>
              <p className="text-gray-600">Metal roofs last 40-70 years, 2-3x longer than asphalt shingles. Copper roofs can last over 100 years.</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-bold text-xl text-gray-900 mb-3">Energy Efficiency</h3>
              <p className="text-gray-600">Reflective surfaces reduce cooling costs by 10-25%. Ideal for hot climates and eco-conscious homeowners.</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-bold text-xl text-gray-900 mb-3">Durability</h3>
              <p className="text-gray-600">Resistant to fire, rot, insects, and extreme weather. Low maintenance with minimal repairs needed.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Metal Types Comparison */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-4">
            Metal Roof Estimate Per Square Foot
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12">
            Compare standing seam metal roof calculator pricing with copper roof cost calculator and other premium materials.
          </p>

          <div className="overflow-x-auto">
            <table className="w-full bg-white rounded-xl shadow-lg overflow-hidden">
              <thead className="bg-gray-800 text-white">
                <tr>
                  <th className="px-6 py-4 text-left font-bold">Metal Type</th>
                  <th className="px-6 py-4 text-left font-bold">Cost per Sq Ft</th>
                  <th className="px-6 py-4 text-left font-bold">Durability</th>
                  <th className="px-6 py-4 text-left font-bold">Appearance</th>
                </tr>
              </thead>
              <tbody>
                {metalTypes.map((type, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="px-6 py-4 font-semibold text-gray-900">{type.name}</td>
                    <td className="px-6 py-4 text-orange-600 font-bold">{type.costPerSqFt}</td>
                    <td className="px-6 py-4 text-gray-700">{type.durability}</td>
                    <td className="px-6 py-4 text-gray-700">{type.appearance}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Tile Roofing Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
            Tile Roof Replacement Cost Calculator
          </h2>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            Clay and concrete tile roofs offer exceptional longevity and aesthetic appeal. While initial costs are higher ($10-$18 per square foot), the 50-100 year lifespan makes them a valuable long-term investment. Tile roofs are ideal for Mediterranean, Spanish Colonial, and Southwestern architectural styles.
          </p>

          <div className="bg-blue-50 border-l-4 border-blue-800 p-6 rounded-r-lg">
            <h3 className="font-bold text-xl text-gray-900 mb-3">Average Tile Roof Installation Cost</h3>
            <p className="text-gray-700">
              <strong>2,000 sq ft home:</strong> $20,000 - $36,000<br />
              <strong>2,500 sq ft home:</strong> $25,000 - $45,000<br />
              <strong>3,000 sq ft home:</strong> $30,000 - $54,000
            </p>
          </div>
        </div>
      </section>

    </div>
  )
}
